import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';

const NotFoundPage = () => (
  <div className="App">
    <Header />
    <main>
      <PageHeader
        title="Página não encontrada"
        subtitle="O endereço acessado não existe ou foi alterado."
        breadcrumb="Erro 404"
      />
      <section className="section text-center">
        <div className="container">
          <Link to="/" className="btn btn-primary">Voltar para a página inicial</Link>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;
